import React from "react"

interface iSeekChart {
  percentageFromLeft: number
  valueOnSeek: string
  seekColorClass: string
}

const SeekChart: React.FC<iSeekChart> = ({
  percentageFromLeft,
  valueOnSeek,
  seekColorClass,
}) => {
  const getPercentageFromLeft = (value: number) => {
    if (value < 6) return 6
    if (value >= 94) return 94
    return value
  }

  return (
    <div className="w-full pt-4">
      <div className="w-full relative h-6">
        <div
          className="absolute"
          style={{
            left: `${getPercentageFromLeft(percentageFromLeft)}%`,
            top: "-30px",
            transitionProperty: "all",
            transitionDuration: "100ms",
          }}
        >
          <div
            className={`shadow px-2 py-0 text-xs 
              text-blue-100 rounded-t 
              rounded-r ${seekColorClass}`}
          >
            {valueOnSeek}
          </div>
          <div
            className={`shadow h-8 rounded-b ${seekColorClass}`}
            style={{ width: "3px" }}
          />
        </div>
        <div
          className="w-full h-4 rounded"
          style={{
            backgroundImage:
              "linear-gradient(90deg, rgb(254, 225, 40) 6%, rgb(34, 139, 34) 24%, rgb(254, 225, 40) 45%, rgb(128, 93, 73) 74%, rgb(160, 65, 59) 96%)",
          }}
        />
      </div>
    </div>
  )
}

export default SeekChart
